/** Mirror of app `src/utils/ticketSaleDates.ts` for widget checkout. */

import {
  calendarDateInTimeZone,
  startOfCalendarDayInTimeZoneMs,
  toLocalCalendarDate,
} from './calendarDate';

export function ticketSaleStartMs(saleStart: string | Date, timeZone?: string): number {
  if (timeZone) {
    return new Date(typeof saleStart === 'string' ? saleStart : saleStart.toISOString()).getTime();
  }
  const cal = toLocalCalendarDate(saleStart);
  cal.setHours(0, 0, 0, 0);
  return cal.getTime();
}

export function ticketSaleEndInclusiveMs(saleEnd: string | Date, timeZone?: string): number {
  if (timeZone) {
    const day = calendarDateInTimeZone(saleEnd, timeZone);
    const next = new Date(day);
    next.setDate(next.getDate() + 1);
    return startOfCalendarDayInTimeZoneMs(next.getFullYear(), next.getMonth(), next.getDate(), timeZone) - 1;
  }
  const cal = toLocalCalendarDate(saleEnd);
  cal.setHours(23, 59, 59, 999);
  return cal.getTime();
}

export function isTicketTierOnSale(
  saleStart?: string | Date | null,
  saleEnd?: string | Date | null,
  nowMs: number = Date.now(),
  timeZone?: string,
): boolean {
  if (saleStart && nowMs < ticketSaleStartMs(saleStart, timeZone)) return false;
  if (saleEnd && nowMs > ticketSaleEndInclusiveMs(saleEnd, timeZone)) return false;
  return true;
}
